import React from 'react';

import { ImmutableTextPreset } from 'redux/modules/text-presets';

import { useTextOverlay } from '../state/TextOverlayProvider';
import { transformPresetToStateStyles } from '../style-transform-utils';

interface UseTextOverlayPresets {
  onSelectPreset: (nextPreset: ImmutableTextPreset) => void;
  selectedPreset: ImmutableTextPreset;
}

const useTextOverlayPresets = (): UseTextOverlayPresets => {
  const {
    draftEditorData,
    onSelectPreset,
    onUpdateOverlay,
    selectedPreset,
    animationsTabExtension,
  } = useTextOverlay();

  const handleSelectPreset = React.useCallback(
    (nextPreset: ImmutableTextPreset): void => {
      const presetToApply =
        !animationsTabExtension?.enabled ||
        animationsTabExtension?.displayConfig.showTabDisabled
          ? (nextPreset.remove('advancedAnimation') as ImmutableTextPreset)
          : nextPreset;

      onSelectPreset(presetToApply);
      onUpdateOverlay(
        () => transformPresetToStateStyles(presetToApply, draftEditorData),
        true,
      );
    },
    [
      animationsTabExtension?.displayConfig.showTabDisabled,
      animationsTabExtension?.enabled,
      draftEditorData,
      onSelectPreset,
      onUpdateOverlay,
    ],
  );

  return {
    onSelectPreset: handleSelectPreset,
    selectedPreset,
  };
};

export default useTextOverlayPresets;
